import { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import "./dashboard.scss";
import { fetchBooking, getDashboardCount } from "../../store/slices/thunk";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import passenger from "../../assets/passenger.png";
import driver from "../../assets/driver-man.png";
import weblogo from "../../assets/weblogo.png";
import car from "../../assets/vehicle.png";
import trips from "../../assets/tripss.png";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";

const vehiclesData = Array.from({ length: 200 }, (_, i) => ({
  name: `Vehicle ${i + 1}`,
  currentLocation: "Location Not Updated",
}));
const ITEMS_PER_PAGE = 5;

const Dashboard = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState({
    vehiclesCount: 0,
    driversCount: 0,
    customersCount: 0,
    bookingCount: 0,
  });
  const [totalCountFoBooking, setTotalCountForBooking] = useState(0);

  const [page, setPage] = useState(1);

  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const filteredData = vehiclesData.filter((vehicle) =>
    vehicle.name.toLowerCase().includes(search.toLowerCase())
  );

  const pageCount = Math.ceil(totalCountFoBooking / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentData = filteredData.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );
  const [loading, setLoading] = useState<boolean>(true);

  const [getAllBooking, setAllBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const DEBOUNCE_DELAY = 500;

  const { filteredData: bookingFilteredData, filters, setFilter, clearFilter } = useClientFilter(getAllBooking);

  useEffect(() => {
    let cancelled = false;
    const handler = setTimeout(async () => {
      setIsLoading(true);
      try {
        const response = await dispatch(
          fetchBooking(page, ITEMS_PER_PAGE, search, "")
        );
        if (cancelled) return;
        if (response && response?.isSuccess) {
          setAllBooking(response?.data?.data || []);
          setTotalCountForBooking(response?.data?.totalCount ?? 0);
        } else {
          setAllBooking([]);
        }
      } catch (error) {
        if (cancelled) return;
        console.log(error);
        setAllBooking([]);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
          setLoading(false);
        }
      }
    }, DEBOUNCE_DELAY);

    return () => {
      cancelled = true;
      clearTimeout(handler);
    };
  }, [search, page, dispatch]);

  const calledOnce = useRef(false);

  useEffect(() => {
    if (calledOnce.current) return;
    calledOnce.current = true;

    const getAllCount = async () => {
      const response = await dispatch(getDashboardCount());
      if (response && response.isSuccess) {
        setTotalCount(response.data);
      } else {
        setTotalCount({
          vehiclesCount: 0,
          driversCount: 0,
          customersCount: 0,
          bookingCount: 0,
        });
      }
    };

    getAllCount();
  }, [dispatch]);
  const gotoDetails = (id: string) => {
    navigate(`/view-Detail/${id}`);
  };

  const gotoAddReminder = () => {
    navigate(`/add-reminder`);
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-content" style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
        <div style={{ display: "grid",   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))"
, gap: "16px", marginBottom: "16px", flexShrink: 0 }}>
          <div>
            <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "20px", position: "relative", overflow: "hidden", minHeight: "130px" }}>
              <div className="d-flex align-items-start">
                <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: "#EFF6FF", width: "48px", height: "48px", borderRadius: "12px", flexShrink: 0 }}>
                  <img src={car} style={{ width: "26px", height: "26px", filter: "brightness(0) saturate(100%) invert(47%) sepia(83%) saturate(4458%) hue-rotate(197deg) brightness(99%) contrast(101%)" }} />
                </div>
                <div className="ms-3" style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#3B82F6", marginBottom: "4px" }}>Total Vehicles</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: "#1f2937", lineHeight: 1 }}>{totalCount.vehiclesCount}</div>
                </div>
              </div>
              <div style={{ position: "absolute", bottom: "14px", right: "16px", width: "80px", height: "30px" }}>
                <svg width="80" height="30" viewBox="0 0 80 30" fill="none">
                  <polyline points="0,22 12,18 24,20 36,14 48,16 60,10 72,12 80,8" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "20px", position: "relative", overflow: "hidden", minHeight: "130px" }}>
              <div className="d-flex align-items-start">
                <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: "#ECFDF5", width: "48px", height: "48px", borderRadius: "12px", flexShrink: 0 }}>
                  <img src={driver} style={{ width: "26px", height: "26px", filter: "brightness(0) saturate(100%) invert(63%) sepia(82%) saturate(459%) hue-rotate(88deg) brightness(95%) contrast(92%)" }} />
                </div>
                <div className="ms-3" style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#22C55E", marginBottom: "4px" }}>Total Drivers</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: "#1f2937", lineHeight: 1 }}>{totalCount.driversCount}</div>
                </div>
              </div>
              <div style={{ position: "absolute", bottom: "14px", right: "16px", width: "80px", height: "30px" }}>
                <svg width="80" height="30" viewBox="0 0 80 30" fill="none">
                  <polyline points="0,20 12,16 24,18 36,12 48,14 60,8 72,10 80,6" stroke="#22C55E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "20px", position: "relative", overflow: "hidden", minHeight: "130px" }}>
              <div className="d-flex align-items-start">
                <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: "#F3E8FF", width: "48px", height: "48px", borderRadius: "12px", flexShrink: 0 }}>
                  <img src={passenger} style={{ width: "26px", height: "26px", filter: "brightness(0) saturate(100%) invert(37%) sepia(94%) saturate(3336%) hue-rotate(242deg) brightness(99%) contrast(101%)" }} />
                </div>
                <div className="ms-3" style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#8B5CF6", marginBottom: "4px" }}>Total Customers</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: "#1f2937", lineHeight: 1 }}>{totalCount.customersCount}</div>
                </div>
              </div>
              <div style={{ position: "absolute", bottom: "14px", right: "16px", width: "80px", height: "30px" }}>
                <svg width="80" height="30" viewBox="0 0 80 30" fill="none">
                  <polyline points="0,18 12,14 24,16 36,10 48,12 60,6 72,8 80,4" stroke="#8B5CF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </div>
            </div>
          </div>

          <div>
            <div className="card border-0" style={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "20px", position: "relative", overflow: "hidden", minHeight: "130px" }}>
              <div className="d-flex align-items-start">
                <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: "#FFF7ED", width: "48px", height: "48px", borderRadius: "12px", flexShrink: 0 }}>
                  <img src={trips} style={{ width: "26px", height: "26px", filter: "brightness(0) saturate(100%) invert(55%) sepia(86%) saturate(2387%) hue-rotate(353deg) brightness(99%) contrast(101%)" }} />
                </div>
                <div className="ms-3" style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#F97316", marginBottom: "4px" }}>Today&apos;s Trips</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: "#1f2937", lineHeight: 1 }}>{totalCount.bookingCount}</div>
                </div>
              </div>
              <div style={{ position: "absolute", bottom: "14px", right: "16px", width: "80px", height: "30px" }}>
                <svg width="80" height="30" viewBox="0 0 80 30" fill="none">
                  <polyline points="0,24 12,20 24,22 36,16 48,18 60,12 72,14 80,10" stroke="#F97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            border: "1px solid #e5e7eb",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <div
            className="w-100 d-flex justify-content-between align-items-center"
            style={{
              padding: "16px 24px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h2
                className="fw-bold fs-4 m-0 p-0"
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#1f2937",
                  margin: 0,
                  letterSpacing: "-0.3px",
                }}
              >
                Trip Listing
              </h2>
              <div style={{ width: "40px", height: "3px", backgroundColor: "#1976d2", marginTop: "6px", borderRadius: "2px" }}></div>
            </div>
            <input
              type="text"
              placeholder="Search by driver..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                outline: "none",
                fontSize: "14px",
                width: "260px",
                backgroundColor: "#f9fafb",
              }}
            />
          </div>
          <div className="dashboard-table-scroll">
            <table
              className="table p-0 m-0"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead style={{ backgroundColor: "#f9fafb" }}>
                <tr>
                  <th scope="col" style={{ padding: "8px 14px", textAlign: "left", fontSize: "13px", fontWeight: 600, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e5e7eb", whiteSpace: "nowrap" }}>Trip Name<FilterPopover column="tripName" filterType="text" currentValue={filters.tripName || ""} onFilterChange={setFilter} onClear={clearFilter} /></th>
                  <th scope="col" style={{ padding: "8px 14px", textAlign: "left", fontSize: "13px", fontWeight: 600, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e5e7eb", whiteSpace: "nowrap" }}>Driver<FilterPopover column="driver.driverName" filterType="text" currentValue={filters["driver.driverName"] || ""} onFilterChange={setFilter} onClear={clearFilter} /></th>
                  <th scope="col" style={{ padding: "8px 14px", textAlign: "left", fontSize: "13px", fontWeight: 600, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e5e7eb", whiteSpace: "nowrap" }}>Total Passenger</th>
                  <th scope="col" style={{ padding: "8px 14px", textAlign: "left", fontSize: "13px", fontWeight: 600, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e5e7eb", whiteSpace: "nowrap" }}>Action</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody>
                  <tr>
                    <td colSpan={8} align="center">
                      <Loader />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {bookingFilteredData.map((booking: any, index) => (
                    <tr
                      key={booking.activityLogId || index}
                      style={{
                        borderBottom: "1px solid #e5e7eb",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f9fafb")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "white")
                      }
                    >
                      <td
                        scope="row"
                        style={{
                          padding: "18px 28px",
                          whiteSpace: "nowrap",
                          color: "#111827",
                          fontSize: "16px",
                        }}
                      >
                        {booking?.tripName || "--"}
                      </td>
                      <td
                        style={{
                          padding: "18px 28px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <img
                          style={{
                            height: "42px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            width: "42px",
                          }}
                          src={booking?.driver?.driverImage || weblogo}
                          onError={(e) => { (e.target as HTMLImageElement).src = weblogo; }}
                          className="rounded-circle "
                        />
                        <span style={{ marginLeft: "10px", fontWeight: 500, color: "#374151" }}>
                          {booking?.driver?.driverName || "--"}
                        </span>{" "}
                      </td>
                      <td
                        style={{
                          padding: "18px 28px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#1976d2", fontWeight: 600 }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                          {booking?.customer.length || 0}
                        </span>
                      </td>
                      <td
                        style={{
                          padding: "18px 28px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <button
                          style={{
                            color: "#2563eb",
                            cursor: "pointer",
                            border: "none",
                            background: "transparent",
                            padding: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "20px",
                            borderRadius: "8px",
                            transition: "background 0.15s",
                          }}
                          onClick={() => gotoDetails(booking.activityLogId)}
                        >
                          <RemoveRedEyeIcon />
                        </button>
                      </td>
                    </tr>
                  ))}
                  {bookingFilteredData.length === 0 && (
                    <tr>
                      <td colSpan={6} align="center">
                        No Booking Found.
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
          <nav style={{ flexShrink: 0 }}>
            <ul className="pagination justify-content-center mt-3">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {(() => {
                const maxVisible = 5;
                let start = Math.max(1, page - Math.floor(maxVisible / 2));
                let end = Math.min(pageCount, start + maxVisible - 1);
                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }
                const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
                return (
                  <>
                    {start > 1 && (
                      <>
                        <li className="page-item">
                          <button className="page-link" onClick={() => setPage(1)}>1</button>
                        </li>
                        {start > 2 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}
                      </>
                    )}
                    {pages.map((p) => (
                      <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                        <button className="page-link" onClick={() => setPage(p)}>
                          {p}
                        </button>
                      </li>
                    ))}
                    {end < pageCount && (
                      <>
                        {end < pageCount - 1 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}
                        <li className="page-item">
                          <button className="page-link" onClick={() => setPage(pageCount)}>
                            {pageCount}
                          </button>
                        </li>
                      </>
                    )}
                  </>
                );
              })()}

              <li
                className={`page-item ${
                  page === pageCount && "disabled"
                }`}
              >
                <button
                  className="page-link"
                  onClick={() =>
                    setPage((p) => Math.min(p + 1, pageCount))
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
